import index from "./feedback.vue";
export default index;
